// utils/auth.js
import {publicApi} from '../utils/axios';

export const loginUser = async (email, password) => {
  const response = await publicApi.post('/users/login', { email, password });
  return response.data;
};

export const registerUser = async (name, email, password, confirmPassword) => {
  const response = await publicApi.post('/users/register', { name, email, password, confirmPassword });
  return response.data;
};

export const loginUserSSO = async (idToken) => {
  const response = await publicApi.post('/users/auth/sso-login', { id_token: idToken });
  return response.data;
};

export const sendResetPasswordEmail = async (email) => {
  const response = await publicApi.post('/users/send-reset-email', { email });
  return response.data;
};

export const handleResetPassword = async (token, newPassword) => {
  await publicApi.post('/users/reset-password-with-token', { token, newPassword });
}

export const wakeUpServer = async () => {
  try {
    await publicApi.get('/users/heartbeat');
    return true;
  } catch (error) {
    console.log('Heartbeat sent to wake up server.');
    return false;
  }
};